import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center ga-1 mb-3" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-center ga-1" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-center ga-1" }
const _hoisted_4 = { class: "d-flex flex-wrap justify-center ga-1" }

import { computed } from "vue";
import type { FiltroEstadisticas } from "@/interfaces/Estadisticas";
import { TRAMOS } from "@/utils/estadisticasEjercitos";


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltrosEstadisticas',
  props: {
    modelValue: {},
    conBando: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// Este año y el anterior, más «Todas»: antes de 2025 apenas hay partidas
const ACTUAL = new Date().getFullYear();
const ANIOS = [ACTUAL, ACTUAL - 1];

const temporadas = computed(() => props.modelValue.temporadas ?? []);
const tramos = computed(() => props.modelValue.tramos ?? []);

// Marca o desmarca una pastilla dentro de su grupo
const alternar = <T,>(lista: T[], valor: T): T[] =>
  lista.includes(valor) ? lista.filter(v => v !== valor) : [...lista, valor];

const cambiar = (cambio: Partial<FiltroEstadisticas>) =>
  emit("update:modelValue", { ...props.modelValue, ...cambio });

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ANIOS, (anio) => {
        return _createVNode(_component_v_chip, {
          key: anio,
          size: "small",
          color: temporadas.value.includes(anio) ? 'primary' : undefined,
          onClick: ($event: any) => (cambiar({ temporadas: alternar(temporadas.value, anio) }))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(anio), 1)
          ]),
          _: 2
        }, 1032, ["color", "onClick"])
      }), 64)),
      _createVNode(_component_v_chip, {
        size: "small",
        color: temporadas.value.length === 0 ? 'primary' : undefined,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (cambiar({ temporadas: [] })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Todas ")
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_chip, {
        size: "small",
        color: tramos.value.length === 0 ? 'primary' : undefined,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (cambiar({ tramos: [] })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Todos los puntos ")
        ]),
        _: 1
      }, 8, ["color"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TRAMOS), (tramo) => {
        return (_openBlock(), _createBlock(_component_v_chip, {
          key: tramo.valor,
          size: "small",
          color: tramos.value.includes(tramo.valor) ? 'primary' : undefined,
          onClick: ($event: any) => (cambiar({ tramos: alternar(tramos.value, tramo.valor) }))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tramo.texto), 1)
          ]),
          _: 2
        }, 1032, ["color", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.conBando)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_chip, {
              size: "small",
              color: !_ctx.modelValue.bando ? 'primary' : undefined,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (cambiar({ bando: null })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Los dos bandos ")
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_v_chip, {
              size: "small",
              color: _ctx.modelValue.bando === 'good' ? 'primary' : undefined,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cambiar({ bando: 'good' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Bien ")
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_v_chip, {
              size: "small",
              color: _ctx.modelValue.bando === 'evil' ? 'primary' : undefined,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cambiar({ bando: 'evil' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Mal ")
              ]),
              _: 1
            }, 8, ["color"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_chip, {
        size: "small",
        color: _ctx.modelValue.amistosas ? 'primary' : undefined,
        "prepend-icon": _ctx.modelValue.amistosas ? 'mdi-check' : undefined,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (cambiar({ amistosas: !_ctx.modelValue.amistosas })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Con amistosas ")
        ]),
        _: 1
      }, 8, ["color", "prepend-icon"])
    ])
  ]))
}
}

})